module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Leibstadt-38edb1b47d6bc55d753af3c86eb3e889.svg";